import { ReactNode, useState } from 'react';
import { ListItem, ListItemText, Avatar, Dialog, ListItemButton, useTheme } from '@mui/material';
import { Connection } from '@domain/connection/models/Connection';
import { APP_CONFIG } from '../../../../config/app.config';
import { ConnectionAuthStatus } from '@features/connections/generic/components/ConnectionAuthStatus';
import ChannelDockCredentialsForm from './ChannelDockCredentialsForm';
import GenericConnectionSettings from '@features/connections/generic/components/GenericConnectionSettings';
import { Icon } from '@shared/icons';

export interface ChannelDockConnectionListItemProps {
  connection: Connection;
  onClick?: (settings: ReactNode) => void;
}

export const ChannelDockConnectionListItem = ({ connection, onClick }: ChannelDockConnectionListItemProps) => {
  const theme = useTheme();
  const [reconnectOpen, setReconnectOpen] = useState(false);

  const handleClick = onClick
    ? () => onClick(<GenericConnectionSettings connectionId={connection.id} />)
    : undefined;

  const content = (
    <>
      <Avatar
        sx={{ width: 60, height: 60, border: 1, borderColor: APP_CONFIG.ui.theme.colors.border, backgroundColor: theme.palette.background.paper }}
        variant="rounded"
        alt={connection.connector.type}
        slotProps={{
          img: {
            style: { objectFit: 'contain' },
          },
        }}
        src={connection.connector.image}
      />

      <ListItemText primary={connection.name} secondary={connection.connector.type} />

      <ConnectionAuthStatus authorized={connection.authorized} onReconnect={() => setReconnectOpen(true)} />

      {onClick && (
        <Icon icon="ChevronRight" color={theme.palette.text.secondary} />
      )}

      <Dialog open={reconnectOpen} onClose={() => setReconnectOpen(false)} maxWidth="sm" fullWidth>
        <ChannelDockCredentialsForm
          reconnectConnectionId={connection.id}
          onNewConnection={() => setReconnectOpen(false)}
          onClose={() => setReconnectOpen(false)}
        />
      </Dialog>
    </>
  );

  if (handleClick) {
    return (
      <ListItemButton sx={{ p: 2, gap: 2 }} onClick={handleClick} key={connection.id}>
        {content}
      </ListItemButton>
    );
  }

  return (
    <ListItem sx={{ p: 2, gap: 2 }} key={connection.id}>
      {content}
    </ListItem>
  );
};
